export const formatDateToStandard = (isoDate: string) => {
  if (!isoDate) {
    return "-";
  }

  const dateTime = isoDate.split("+")[0];

  const [date, time] = dateTime.split("T");

  return `${date} | ${time}`;
};
